"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlexBoxDiv = void 0;
const vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
// export function StickersFlexBox(props: StickersFlexBoxProps): JSX.Element {
//   return (
//     <FlexBoxDiv>
//       {props.children}
//     </FlexBoxDiv>
//   )
// }
exports.FlexBoxDiv = (0, vizportalclient_common_components_1.divWithStyle)('flex-box-div', {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    gap: '8px',
    height: '100%',
});
//# sourceMappingURL=StickersFlexBox.js.map